import { useExperiment } from 'utils/experiments'
import { useCurrentPlan } from './useCurrentPlan'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import useResponsiveDesign from './useResponsiveDesign'
import { useCurrentWorkspace } from './useCurrentWorkspace'
import { useMemo } from 'react'

export const useAPMobileWeb = (): boolean => {
  const { isMobile, isIOSNative } = useResponsiveDesign()

  const workspace = useCurrentWorkspace()
  const isAutopilot = useMemo(() => !!workspace?.is_virtual_marketer, [workspace])

  const variant = useExperiment('mobile_calendar_access')
  const isAllowed = useMemo(() => variant === 'allow', [variant])

  const { data } = useCurrentPlan()
  const isGrowth = useMemo(() => data?.plan === PaymentPlanKey.BlazeAutopilotGrowth, [data])

  const isAPMobileWeb = useMemo(() => {
    const isStrictlyMobile = isMobile && !isIOSNative
    return isStrictlyMobile && isAllowed && !isGrowth && isAutopilot
  }, [isAllowed, isAutopilot, isGrowth, isIOSNative, isMobile])

  return isAPMobileWeb
}
